/**
 * useFetch / useAsyncData の明示キーを組み立てる。
 * 暗黙キーはファイルパス由来のため、リソース識別子を含む明示キーを必ず指定する。
 * 各パートは encodeURIComponent で符号化するため、値に区切り文字 ':' が含まれても
 * 別のキーと衝突しない（例: ('x:y', 'z') と ('x', 'y:z') は異なるキーになる）。
 */
export const buildAsyncDataKey = (prefix: string, ...parts: string[]): string =>
  [prefix, ...parts.map((part) => encodeURIComponent(part))].join(':')
